import {axios} from 'services/axios';

export default function updateACSService(body) {
    return axios.put(`/Service/ACSDirectRouting`, body);
}
